/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createPagedResultOfDataExportFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type PagedResultOfDataExport } from '../../models/index.js';
// @ts-ignore
import { CustomersRequestBuilderRequestsMetadata, type CustomersRequestBuilder } from './customers/index.js';
// @ts-ignore
import { FormatsRequestBuilderRequestsMetadata, type FormatsRequestBuilder } from './formats/index.js';
// @ts-ignore
import { ExportsItemRequestBuilderNavigationMetadata, type ExportsItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { OrdersRequestBuilderNavigationMetadata, type OrdersRequestBuilder } from './orders/index.js';
// @ts-ignore
import { ProductsRequestBuilderRequestsMetadata, type ProductsRequestBuilder } from './products/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/exports
 */
export interface ExportsRequestBuilder extends BaseRequestBuilder<ExportsRequestBuilder> {
    /**
     * The customers property
     */
    get customers(): CustomersRequestBuilder;
    /**
     * The formats property
     */
    get formats(): FormatsRequestBuilder;
    /**
     * The orders property
     */
    get orders(): OrdersRequestBuilder;
    /**
     * The products property
     */
    get products(): ProductsRequestBuilder;
    /**
     * Gets an item from the MomentumAPI.api.exports.item collection
     * @param id Unique identifier of the item
     * @returns {ExportsItemRequestBuilder}
     */
     byId(id: string) : ExportsItemRequestBuilder;
    /**
     * Lists exports for an organization, optionally filtered by date, type, and paginated.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PagedResultOfDataExport>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<ExportsRequestBuilderGetQueryParameters> | undefined) : Promise<PagedResultOfDataExport | undefined>;
    /**
     * Lists exports for an organization, optionally filtered by date, type, and paginated.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<ExportsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Lists exports for an organization, optionally filtered by date, type, and paginated.
 */
export interface ExportsRequestBuilderGetQueryParameters {
    /**
     * Gets or sets the filters for the request, this is optionalAcceptable operators are: starts with, contains, not contains, ends with, equals, not equals
     */
    filters?: string[];
    /**
     * Gets or sets the page number for the request. Default value is 1.
     */
    pageNumber?: number;
    /**
     * Gets or sets the page size for the request. Default value is 25.
     */
    pageSize?: number;
    /**
     * Gets or sets the sort direction. Can be "ASC" or "DESC". Default value is "asc".
     */
    sortDirection?: string;
    /**
     * Gets or sets the field to sort on. Default value is "Name".
     */
    sortOn?: string;
}
/**
 * Uri template for the request builder.
 */
export const ExportsRequestBuilderUriTemplate = "{+baseurl}/api/exports?pageNumber={pageNumber}&pageSize={pageSize}&sortDirection={sortDirection}&sortOn={sortOn}{&filters*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ExportsRequestBuilderNavigationMetadata: Record<Exclude<keyof ExportsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byId: {
        navigationMetadata: ExportsItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["id"],
    },
    customers: {
        requestsMetadata: CustomersRequestBuilderRequestsMetadata,
    },
    formats: {
        requestsMetadata: FormatsRequestBuilderRequestsMetadata,
    },
    orders: {
        navigationMetadata: OrdersRequestBuilderNavigationMetadata,
    },
    products: {
        requestsMetadata: ProductsRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ExportsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ExportsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPagedResultOfDataExportFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
